import React from "react";
import { CgDetailsMore } from "react-icons/cg";
import { RiDeleteBin6Line } from "react-icons/ri";
import { FaChevronDown, FaExpand, FaCompress } from "react-icons/fa";

function ChatHeader({
    isAuthenticated,
    conversation,
    clearChat,
    summarizeConversation,
    toggleMinimize,
    toggleFullscreen,
    fullscreen,
    isMobile
}) {
    const styles = {
        header: {
            padding: '20px',
            backgroundColor: '#f8f9fa',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderBottom: '1px solid #e9ecef'
        },
        headerControls: {
            display: 'flex',
            gap: '10px'
        },
        iconButton: {
            background: 'none',
            border: 'none',
            color: '#777',
            cursor: 'pointer',
            padding: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '30px',
            height: '30px',
            borderRadius: '4px',
            transition: 'background-color 0.2s'
        }
    };

    return (
        <div style={styles.header}>
            <div>
                <h5 className="mb-0 fw-bold"
                    style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    Copia247
                </h5>
                <p className="text-muted mb-0 small">Powered by Copia AI</p>
            </div>

            <div style={styles.headerControls}>
                {isAuthenticated && conversation.length > 4 && (
                    <button
                        style={styles.iconButton}
                        onClick={summarizeConversation}
                        className="summary-btn"
                        title="Summarise conversation"
                    >
                        <CgDetailsMore />
                    </button>
                )}

                {isAuthenticated && conversation.length > 0 && (
                    <button
                        style={styles.iconButton}
                        className="clear-btn"
                        onClick={clearChat}
                        title="Clear chat history"
                    >
                        <RiDeleteBin6Line />
                    </button>
                )}

                {(!isMobile || fullscreen) && (
                    <button
                        style={styles.iconButton}
                        className="fullscreen-btn"
                        onClick={toggleFullscreen}
                        title={fullscreen ? "Exit fullscreen" : "Enter fullscreen"}
                    >
                        {fullscreen ? <FaCompress /> : <FaExpand />}
                    </button>
                )}

                {!fullscreen && (
                    <button
                        style={styles.iconButton}
                        className="minimize-btn"
                        onClick={toggleMinimize}
                        title="Minimise"
                    >
                        <FaChevronDown />
                    </button>
                )}
            </div>
        </div>
    );
}

export default ChatHeader;